export const SET_LOAD_INFO_USER_STATE = 'SET_LOAD_INFO_USER_STATE';

export default function setInfoUser(payload) {
  return {
    type: SET_LOAD_INFO_USER_STATE,
    payload,
  };
}
